import { ref } from 'vue'

import { trueOnce } from '@/utils/use'

export const messenger = ref<boolean>(false)
export const messengerOnce = trueOnce(messenger)
